export default __webpack_public_path__ + "static/media/logo_xplore_orizzontale.ba5215c4.png";